import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { TaxonomyService, TenantService, UserService } from "../services";
import { Observable, of } from "rxjs";
import { map, mergeMap } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class TrimmedPublishedTaxonomyResolver implements Resolve<any> {

    constructor(private userService: UserService, private taxonomyService: TaxonomyService, private tenantService: TenantService) {}

    resolve(): Observable<any> {
        return this.tenantService.getUnauthTenantInfo()
        .pipe(
            map(tenant => this.userService.getCurrentUser() || tenant.settings.publicTopics === 'true'),
            mergeMap(useTax => useTax ? this.taxonomyService.getTenantTaxonomy(true, true, true) : of([]))
        );
    }
}